/* eslint-disable no-use-before-define */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { useController } from 'react-hook-form'
import * as S from './style'

const FieldDropdown = ({ labelText, name, control, options, ...restProps }) => {
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error }
  } = useController({ name, control })

  return (
    <S.Wrapper>
      <S.Label htmlFor={name}>{labelText}</S.Label>
      <S.Select
        id={name}
        defaultValue=""
        value={value}
        error={error}
        onChange={onChange}
        onBlur={onBlur}
        ref={ref}
        {...restProps}
      >
        <S.Option disabled hidden value="">
          Selecione
        </S.Option>
        {options.map((option) => (
          <S.Option key={option} value={option}>
            {option}
          </S.Option>
        ))}
      </S.Select>
      {error && <S.Error>{processError(error).message}</S.Error>}
    </S.Wrapper>
  )
}

const processError = (error) => {
  if (error.type === 'typeError') {
    return { ...error, message: 'Caracter inesperado e inválido!' }
  }
  return error
}

export { FieldDropdown }
